import { render, staticRenderFns } from "./AttendancesCreate.vue?vue&type=template&id=5464efb4&scoped=true"
import script from "./AttendancesCreate.vue?vue&type=script&lang=js"
export * from "./AttendancesCreate.vue?vue&type=script&lang=js"
import style0 from "./AttendancesCreate.vue?vue&type=style&index=0&id=5464efb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5464efb4",
  null
  
)

export default component.exports